export default __webpack_public_path__ + "static/media/extingaImg_1.caceb1b7.png";